// extracted by mini-css-extract-plugin
export default {"clientGraph":"LineChart_clientGraph__85oD5"};